<template>
    <div id="social-copir">
        <div class="soc-wrap">
            <div class="soc">
            <a href="https://vk.com/club140813823"><img src="../assets/img/vk.svg"></a>
            <a href="https://www.instagram.com/ltgcam/"><img src="../assets/img/inst.svg"></a>
            <a href="https://www.youtube.com/channel/UCQ_k8FfD7xm6dT4K6MO-yUA?guided_help_flow=3"><img src="../assets/img/yt.svg"></a>
            <a href="https://www.facebook.com/ltgcam/"><img src="../assets/img/fb.svg"></a>
            </div>
            <div class="cop">
                <a href="http://profilaktika.agency">
                    <img src="../assets/img/copir.svg">
                </a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "SocialCopir",
}

</script>
<style lang="scss">
    #social-copir {
        width:100%;
        height:30px;
        position:fixed;
        left:0;
        bottom:40px;
        z-index:99;
    }
    .soc-wrap {
        width:74%;
        min-width:1000px;
        height:100%;
        margin:auto
    }
    .soc {
        text-align: left;
        img {
            width:15px;
            height:auto
        }
        a { 
            margin-left:10px
        }
    }
    .cop,
    .soc {
        width:50%;
        float:left;
        height:100%
    }
    .cop {
        text-align: right;
    }
    .cop img {
        width:100px;
        height:auto
    }

    @media ( max-width:1024px ) {
        #social-copir {
            position:static;
            width:auto;
            padding:5vh
        }
        .soc-wrap {
            width:auto;
            min-width:0
        }
        .soc {
            pointer-events:none;
            display:block;
            position:fixed;
            z-index:9999;
            left:0;
            bottom:0;
            height:30px;
            padding:5vh;
            padding-bottom:2vh;
            opacity:0;
            transition:opacity .2s ease
        }
        .cop,
        .soc {
            width:100%
        }
        .cop {
            float:none
        }
        .cop img {
            width:80px
        }
        .mobile_menu_open .soc {
            opacity:1;
            transition:opacity .2s ease .4s;
            pointer-events:all;
            width:100%;
            background-color:#312f2f
        }
    }

</style>




// WEBPACK FOOTER //
// src/components/SocialCopir.vue